import PropTypes from 'prop-types';
import { composeEvent } from '@icp/utils';
import { InputNumber } from 'antd';
import { HELPER_TEXT_TYPES } from '@icp/form-renderer-core';
import { useState, useEffect } from 'react';
import FieldTitle from '../../FieldTitle';
import FormHelperText from '../../FormHelperText';

function NumberPickerAnt(props) {
  const {
    id,
    title,
    value: valueProp,
    disabled,
    readonly,
    componentProps,
    fieldTitleProps,
    validation,
    status,
    helpers,
    onChange,
    onTouchChanged,
    onBlur,
    min,
    max,
    step,
    precision,
    readonlyText,
  } = props;

  const { changeDelayToBlur, stringMode, ...otherComponentProps } = componentProps;

  const [value, setValue] = useState(valueProp);

  useEffect(() => {
    setValue(valueProp);
  }, [valueProp]);

  const handleChange = (newValue) => {
    setValue(newValue);

    if (!changeDelayToBlur) {
      onChange(newValue);
    }
  };

  const handleBlur = () => {
    if (changeDelayToBlur) {
      onChange(value);
    }
    if (onTouchChanged) {
      onTouchChanged();
    }
  };

  return (
    <>
      <FieldTitle required={validation?.required} {...fieldTitleProps}>
        {title}
      </FieldTitle>
      <div>
        {readonly ? (
          <span className="readonly-text">{readonlyText}</span>
        ) : (
          <InputNumber
            type="number"
            {...otherComponentProps}
            stringMode={stringMode}
            name={id}
            value={value}
            min={min}
            max={max}
            step={step}
            precision={precision}
            disabled={disabled}
            onChange={handleChange}
            onBlur={composeEvent(handleBlur, onBlur)}
            status={status}
          />
        )}
        <FormHelperText helpers={helpers} />
      </div>
    </>
  );
}

NumberPickerAnt.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  componentProps: PropTypes.shape({
    changeDelayToBlur: PropTypes.bool,
    stringMode: PropTypes.bool,
  }),
  fieldTitleProps: PropTypes.shape({}),
  validation: PropTypes.shape({
    required: PropTypes.bool,
  }),
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  status: PropTypes.oneOf(HELPER_TEXT_TYPES),
  helpers: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.oneOf(HELPER_TEXT_TYPES),
      text: PropTypes.string,
    }),
  ),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchChanged: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  precision: PropTypes.number,
  readonlyText: PropTypes.string,
};

export default NumberPickerAnt;
